
export enum ROUTES {
	HOME = '/',

	ABOUT = '/about',

	MINISTRIES = '/ministries',
	MINISTRY_DETAIL = '/ministries/:ministryId',

	SCHOOLS = '/schools',
	SCHOOL_DETAIL = '/schools/:schoolKey/:schoolId',

	EVENTS = '/events',
	EVENT_DETAIL = '/events/:eventKey/:eventId',

	BLOGS = '/blogs',
	BLOG_DETAIL = '/blogs/:blogKey/:blogId',

	STORE = '/store',
	PRODUCT_DETAIL = '/store/product/:productId',

	CHECKOUT = '/checkout',

	ORDER_SUCCESS = '/order-success',
	
	QR_LANDING = '/qr',
	
	NOT_FOUND = '/404',

}